// Configuración de Google Maps API
export const GOOGLE_MAPS_API_KEY = "AIzaSyCXHvK8LVhzwLEAZAcwIwMIft8ruBbnMWw";

// Configuración del mapa
export const MAP_CONFIG = {
  center: {
    lat: 19.4326,
    lng: -99.1332
  },
  zoom: 11,
  mapContainerStyle: {
    width: '100%',
    height: '100%'
  }
};

// Librerías de Google Maps que necesitamos
export const GOOGLE_MAPS_LIBRARIES: ("geometry" | "places" | "drawing" | "visualization")[] = ["geometry"];
